import { Box, BoxProps } from '@opendoor/bricks-next';
import LazyLoad from 'components/helpers/LazyLoad';

interface ContainerProps extends BoxProps {
  children: React.ReactNode;
  noSectionSpacing?: boolean;
}

const Container = ({
  children,
  backgroundColor,
  style,
  noSectionSpacing,
  ...props
}: ContainerProps) => {
  return (
    <LazyLoad className={noSectionSpacing ? undefined : 'lp-section'}>
      <Box backgroundColor={backgroundColor} style={style}>
        <Box
          display="block"
          maxWidth={1440}
          paddingHorizontal="$10x"
          $largerThanSM={{ paddingHorizontal: '$20x' }}
          $largerThanMD={{ paddingHorizontal: '$32x' }}
          width="100%"
          marginHorizontal="auto"
          {...props}
        >
          {children}
        </Box>
      </Box>
    </LazyLoad>
  );
};

const NetProceedsCalculatorContainer = ({ children, ...props }: ContainerProps) => (
  <Box
    display="block"
    maxWidth={1440}
    paddingHorizontal="$10x"
    $largerThanSM={{ paddingHorizontal: '$20x' }}
    $largerThanMD={{ paddingHorizontal: '$32x' }}
    width="100%"
    marginHorizontal="auto"
    {...props}
  >
    {children}
  </Box>
);

const LandingPageSectionContainer = ({ children, ...props }: ContainerProps) => {
  return (
    <LazyLoad className="lp-section">
      <Box
        marginTop="$16x"
        display="block"
        maxWidth={1440}
        paddingHorizontal="$10x"
        $largerThanSM={{ paddingHorizontal: '$20x' }}
        $largerThanMD={{ paddingHorizontal: '$32x' }}
        width="100%"
        marginHorizontal="auto"
        {...props}
      >
        {children}
      </Box>
    </LazyLoad>
  );
};

export { LandingPageSectionContainer, NetProceedsCalculatorContainer };

export default Container;
